<template>
    <table class="table table-striped table-condensed">
        <thead>
        <tr>
            <th class="col-xs-6">
                <a href="#" @click.prevent="sort('month')">
                    Month <i class="fa fa-sort"></i>
                </a>
            </th>

            <th class="col-xs-4">
                <a href="#" @click.prevent="sort('index')">
                    Index <i class="fa fa-sort"></i>
                </a>
            </th>

            <th class="col-xs-4">
                <a href="#" @click.prevent="sort(valueColumn)">
                    {{ valueHeadline }} <i class="fa fa-sort"></i>
                </a>
            </th>

            <th class="col-xs-4">
                <a href="#" @click.prevent="sort(targetColumn)">
                    Target <i class="fa fa-sort"></i>
                </a>
            </th>

            <th class="col-xs-6">
                <a href="#" @click.prevent="sort('difference')">
                    Difference <i class="fa fa-sort"></i>
                </a>
            </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="row in sortedRows">
            <td>
                {{ row.month | monthName }}
            </td>

            <td>
                <index-number :value="getIndex(row)"></index-number>
            </td>

            <td>
                {{ format(row[valueColumn]) }}
            </td>

            <td>
                <span v-if="metricType === 'revenue'">
                    {{ format(row[targetColumn]) }}
                </span>

                <span v-else>
                    N/A
                </span>
            </td>

            <td>
                <difference-number v-if="metricType === 'revenue'" :value="getDifference(row)"></difference-number>

                <span v-else>
                    N/A
                </span>
            </td>
        </tr>
        </tbody>

        <tfoot>
        <tr>
            <td>
                <strong>
                    Total
                </strong>
            </td>

            <td>
                <strong>
                    <index-number :value="totalIndex"></index-number>
                </strong>
            </td>

            <td>
                <strong>
                    {{ format(totalValue) }}
                </strong>
            </td>

            <td>
                <strong v-if="metricType === 'revenue'">
                    {{ format(totalTarget) }}
                </strong>

                <strong v-else>
                    N/A
                </strong>
            </td>

            <td>
                <strong v-if="metricType === 'revenue'">
                    <difference-number :value="totalDifference"></difference-number>
                </strong>

                <strong v-else>
                    N/A
                </strong>
            </td>
        </tr>
        </tfoot>
    </table>
</template>

<script>
    import moment from 'moment'
    import DifferenceNumber from '@/components/Numbers/DifferenceNumber'
    import IndexNumber from '@/components/Numbers/IndexNumber'

    export default {
        components: {DifferenceNumber, IndexNumber},

        props: ['metricType', 'section', 'rows'],

        data() {
            return {
                sortBy: 'month',
                sortDirection: -1,
            }
        },

        computed: {
            valueColumn() {
                if (this.section == null || this.section === '') {
                    return 'value'
                }

                if (this.section === 'new') {
                    return 'new'
                }

                if (this.section === 'renewal') {
                    return 'total_renewal'
                }
            },

            targetColumn() {
                if (this.section == null || this.section === '') {
                    return 'target'
                }

                if (this.section === 'new') {
                    return 'new_target'
                }

                if (this.section === 'renewal') {
                    return 'renewal_target'
                }
            },

            sortedRows() {
                return this.rows.sort((a, b) => {
                    if (this.sortBy === 'index') {
                        return this.getIndex(a) > this.getIndex(b) ? -this.sortDirection : this.sortDirection
                    }

                    if (this.sortBy === 'difference') {
                        return this.getDifference(a) > this.getDifference(b) ? -this.sortDirection : this.sortDirection
                    }

                    return a[this.sortBy] > b[this.sortBy] ? -this.sortDirection : this.sortDirection
                })
            },

            totalIndex() {
                if (!this.totalTarget) {
                    return null
                }

                return this.totalValue / this.totalTarget * 100
            },

            totalValue() {
                return this.rows.reduce((total, row) => {
                    return total + row[this.valueColumn]
                }, 0)
            },

            totalTarget() {
                return this.rows.reduce((total, row) => {
                    return total + row[this.targetColumn]
                }, 0)
            },

            totalDifference() {
                return this.rows.reduce((total, row) => {
                    return total + this.getDifference(row)
                }, 0)
            },

            valueHeadline() {
                if (this.metricType === 'revenue') {
                    return 'Revenue'
                }

                return 'Count'
            }
        },

        methods: {
            sort(key) {
                if (this.sortBy === key) {
                    return this.sortDirection = -this.sortDirection
                }

                this.sortDirection = key === 'month' ? -1 : 1

                this.sortBy = key
            },

            format(value) {
                if (this.metricType === 'revenue') {
                    return this.$options.filters.price(value)
                }

                return this.$options.filters.number(value)
            },

            getDifference(row) {
                return row[this.valueColumn] - row[this.targetColumn]
            },

            getIndex(row) {
                return row[this.targetColumn] ? row[this.valueColumn] / row[this.targetColumn] * 100 : null
            }
        },

        filters: {
            monthName(value) {
                return moment(value).format('MMMM')
            }
        }
    }
</script>
